import { useEffect } from 'react';
import { useOneTrustContext } from '@app/onetrust';
import { pruneReadIds } from '../storage/localStorage';

/**
 * Trigger a one-time, self-throttled prune of the stored read set on app mount.
 *
 * Prune is self-contained (it reads dates from its own storage), so this hook
 * needs no data — it only decides whether to run based on analytics consent.
 * pruneReadIds() additionally no-ops if it already ran today.
 */
export const useUnreadPrune = (): void => {
  const { analyticsOptOut } = useOneTrustContext();

  useEffect(() => {
    if (analyticsOptOut) {
      return;
    }

    pruneReadIds();
  }, [analyticsOptOut]);
};
